import BackgroundImg from '../../Assets/Imgs/img-login.jpg'

export const GridSx = {
    width: '100%',
    height: '100vh',
    backgroundImage: `url(${BackgroundImg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
}

export const SxOneForm = {
    minWidth: '320px',
    maxWidth: '340px',
    minHeight: '300px',
    maxHeight: '340px',
    background: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '15px',
    backdropFilter: 'blur(12px)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    boxShadow: '0 0 25px rgba(138, 5, 190, 0.4)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    transition: 'all 0.3s ease-in-out'
}

export const TypographySx = {
    color: '#8A05BE',
    textShadow: '1px 1px 2px #e7adfd',
    fontWeight: 'bold'
}

export const buttonStyle = {
    mt: 1,
    background: 'linear-gradient(90deg, #8A05BE 20%,rgba(76, 0, 255, 0.74) 100%)',
    color: '#fff',
    fontWeight: 'bold',
    borderRadius: '8px',
    padding: '8px 26px',
    textTransform: 'none',
    transition: 'all 0.25s ease',
    boxShadow: '0 4px 15px rgba(138, 5, 190, 0.3)',
    '&:active': {
        transform: 'scale(0.98)'
    },
    width: '70%'
}

export const inputStyle = {
    width: '100%',
    height: '40px',
    borderRadius: '8px',
    background: 'rgba(255, 255, 255, 0.8)',
    fontWeight: 500,
    fontSize: '14px',
    outline: 'none',
    boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.05)',
    color: 'rgb(107, 8, 201)',
    '&::placeholder': {
        color: 'rgba(90, 40, 120, 0.6)'
    },
    '&:focused': {
        background: 'rgba(255, 255, 255, 0.9)',
        boxShadow: '0 0 5px rgb(180, 100, 255)'
    }
}
